import { defineWebformElementMapper } from '../defineWebformElementMapper'

export default defineWebformElementMapper(['WebformElementEmail'], () => {
  return {
    $formkit: 'email',
    validation: [['email']],
  }
})
